import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../assets/avatar.png";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
             I am a final year B.E. (Computer Engineering) student at Thapar Institute of Engineering and Technology. I started my journey of programming by learning C++ as a language which created my interest in Problem Solving by solving Data Structures and Algorithm questions on Leetcode.
             <br />
              In my graduation journey, I have learned various languages from which I have tried to upskill my tech stack. Some of them are Database Management, AR & VR, Computer Vision. Apart from that, I have also done Web Development in both frontend as well as backend technologies. 
              <br />

              <br />
              <br />I feel comfortable with &nbsp;
              <i>
                <b className="purple"> C++, HTML, CSS, JavaScript, React.js, Node.js, SQL  </b>
              </i>
              <br />
              <br />
              My current focus is on learning &nbsp;
              <i>
                <b className="purple">
                  TypeScript, React.js , Firebase and solving problems on LeetCode.
                </b>
              </i>
              <br />
              <br />
              
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" width="275px" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/prinzu"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:prinzuchoudhury@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fa fa-envelope"></i>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/prinzuchoudhury"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-github"></i>
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
